import React, {useCallback, useEffect, useState} from 'react';
import {RouteList} from "../../../../components/admin/route/RouteList";
import {ApiQueryParam, ApiService, filter} from "../../../../service/ApiService";
import {routeResultCollectionType, routeResultType} from "../../../../types/Api/RouteResultType";
import {routeHydrator} from "../../../../models/hydrator/routeHydrator";
import {route} from "../../../../models/route";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Pagination} from "../../../../components/admin/Pagination";
import {Tab} from "../../../../components/admin/route/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState([] as filter[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);
  const [routes, setRoutes] = useState([] as route[]);

  const findRoute = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    filter.forEach((f: filter) => apiFilters.addFilter(f));

    apiFilters.addSort({by: 'rideDate', direction: 'DESC'});
    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<routeResultCollectionType> = ApiService.get('/route', apiFilters) as Promise<routeResultCollectionType>;

    result
      .then((r: routeResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setRoutes(r._embedded.routes.map((route: routeResultType) => {
          return routeHydrator.hydrate(route);
        }));
      })
      .catch((e) => {
        console.log(e);
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setRoutes([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, filter, page]);

  useEffect(() => {
    findRoute();
  }, [findRoute]);

  return (
    <>
      <BoxTitle title="Gestion des parcours"/>
      <Tab/>
      <RouteList routes={routes} loading={loading} refresh={findRoute}
                 filter={(filter: filter[]) => {
                   setFilter(filter)
                 }}
      />
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/route/route/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un parcours
        </NavLink>
      </div>
    </>
  )
}
